/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useState } from 'react';
import { Drawer, Spin, message, Modal } from 'antd';
import { useDispatch } from 'react-redux';
import {
	createEmailTemplate,
	updateEmailTemplate,
	deleteEmailTemplate,
	getEmailTemplateById,
} from '../../redux/emailTemplateSlice';
import EmailTemplateForm from './EmailTemplateForm';
import ShowConfirmClose from '../Modals/ShowConfirmClose';

const DrawerEmailTemplate = ({ templateId, onClose, brandPrimary }) => {
	const dispatch = useDispatch();
	const [template, setTemplate] = useState(undefined);
	const [loading, setLoading] = useState(false);
	const [saving, setSaving] = useState(false);
	const [unsavedChanges, setUnsavedChanges] = useState(false);
	const [confirmationOpen, setConfirmationOpen] = useState(false);

	useEffect(() => {
		if (templateId) {
			setLoading(true);
			dispatch(getEmailTemplateById(templateId))
				.unwrap()
				.then((res) => setTemplate(res))
				.catch(() => {
					message.error('Failed to load template');
					onClose();
				})
				.finally(() => setLoading(false));
		}
	}, [templateId]);

	const handleClose = useCallback(
		(hasUnsaved) => {
			if (hasUnsaved && !confirmationOpen) {
				setConfirmationOpen(true);
				ShowConfirmClose(() => {
					setConfirmationOpen(false);
					onClose();
				}, brandPrimary);
			} else {
				onClose();
			}
		},
		[onClose, confirmationOpen, brandPrimary],
	);

	const handleSave = (values) => {
		setSaving(true);
		const action = templateId
			? updateEmailTemplate({ id: templateId, data: values })
			: createEmailTemplate(values);

		dispatch(action)
			.unwrap()
			.then(() => {
				message.success(`Template ${templateId ? 'updated' : 'created'} successfully`);
				onClose();
			})
			.catch((e) => {
				if (e?.message === 'EMAIL_TEMPLATE_ALREADY_EXISTS') {
					message.error('A template with this name already exists');
				} else {
					message.error(e?.message || 'Failed to save template');
				}
			})
			.finally(() => setSaving(false));
	};

	const handleDelete = () => {
		Modal.confirm({
			title: 'Delete Template',
			content: 'Are you sure you want to delete this template? This cannot be undone.',
			okText: 'Delete',
			okButtonProps: { danger: true },
			onOk: () => {
				dispatch(deleteEmailTemplate(templateId))
					.unwrap()
					.then(() => {
						message.success('Template deleted');
						onClose();
					})
					.catch(() => message.error('Failed to delete template'));
			},
		});
	};

	return (
		<Drawer
			width={640}
			title={templateId ? 'Edit Template' : 'Add Template'}
			placement='right'
			onClose={() => handleClose(unsavedChanges)}
			open>
			<Spin size='large' spinning={loading} style={{ marginTop: 64 }} delay={500}>
				{!loading && (
					<EmailTemplateForm
						template={template}
						onSave={handleSave}
						onCancel={handleClose}
						onDelete={templateId ? handleDelete : null}
						saving={saving}
						unsavedChanges={unsavedChanges}
						setUnsavedChanges={setUnsavedChanges}
					/>
				)}
			</Spin>
		</Drawer>
	);
};

export default DrawerEmailTemplate;
